import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { FloatingTooltip } from '../../../../Floating'
import { Rating, RATING_ITEM_SIZE, RatingEditModal } from '../../../../Rating'

function NewsboardPostRating(props) {
  const { request } = props

  const [show, setShowModal] = useState(false)

  const { t } = useTranslation()

  function handleClick() {
    setShowModal(true)
  }

  function handleCloseModal() {
    setShowModal(false)
  }

  const { id, rating } = request

  return (
    <>
      <FloatingTooltip content={t('Newsboard.EditRatingTooltipKey')}>
        <Rating
          interactable
          itemSize={RATING_ITEM_SIZE.size24}
          rating={rating?.value}
          onClickRow={handleClick}
        />
      </FloatingTooltip>
      {show ? (
        <RatingEditModal
          ratingData={rating}
          requestId={id}
          onClose={handleCloseModal}
          onUpdateListData={props.onUpdateListData}
        />
      ) : null}
    </>
  )
}

export default NewsboardPostRating
